export { default } from './ImageSingleChoice.js';
